module.exports = __webpack_public_path__ + "img/testimonial-jody.2ea8b0e8.png";